import { MarkerPoint } from "../../../components/common/Galleries/BriaCanvas";
import { IBrushSettings } from "../../../models/brush";
import { AsyncProps } from "../../../utils/useImageUtils";
import { DEFAULT_BRUSH } from "../ImageToImage/Config/Features/EraseObject/eraseObjectConstants";

export type KeyPoint = MarkerPoint & { type: "positive" | "negative" };

export type VideoSegmentationResponse = {
	mask_url: string;
};

export type TgVideoGenerationConfigType = {
	model_id: string;
	image: string; // URL or base64 string
	seed?: number;
};

export const defaultTgVideoGenerationConfig: TgVideoGenerationConfigType = {
	model_id: "",
	image: "",
	seed: undefined,
};

export type VideoSegmentationConfigType = {
	video: string;
	prompt?: string;
	key_points?: KeyPoint[];
	frame_index?: number;
	mask_url?: string;
};

export const defaultVideoSegmentationConfig: VideoSegmentationConfigType = {
	video: "",
	key_points: [],
	frame_index: 0,
};

export const defaultKeypointBrushConfigs: IBrushSettings = { ...DEFAULT_BRUSH, brushMode: "point" };

export type VideoSegmentationTools = "mask_by_prompt" | "mask_by_keypoints";

export const VIDEO_SEGMENTATION_ASYNC_PROPS: Record<VideoSegmentationTools, AsyncProps> = {
	mask_by_prompt: {
		maxAttempts: 45,
		sleepSecs: 2,
	},
	mask_by_keypoints: {
		maxAttempts: 45,
		sleepSecs: 2,
	},
};
